document.addEventListener('click', event => {
  const thumb = event.target.closest('[data-gallery-target]');
  if (thumb) {
    const target = document.getElementById(thumb.dataset.galleryTarget);
    const track = target?.closest('.media-track');
    if (track) {
      event.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({left: target.offsetLeft, behavior: reduce ? 'instant' : 'smooth'});
    }
  }
  const openMenu = document.querySelector('.mobile-menu[open]');
  if (openMenu && !openMenu.contains(event.target)) openMenu.removeAttribute('open');
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    const openMenu = document.querySelector('.mobile-menu[open]');
    if (openMenu) {
      openMenu.removeAttribute('open');
      openMenu.querySelector('summary').focus();
    }
  }
});
document.addEventListener('change', event => {
  const select = event.target.closest('[data-variant-url]');
  if (select) {
    const url = new URL(select.dataset.variantUrl, window.location.origin);
    url.searchParams.set('variant', select.value);
    window.location.assign(url.toString());
  }
});

function sizeVelaiGallery(track) {
  const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
  const active = track.children[index] || track.firstElementChild;
  if (active && active.offsetHeight > 0) track.style.height = active.offsetHeight + 'px';
}
function initializeVelaiGalleries(root = document) {
  root.querySelectorAll('.media-track').forEach(track => {
    if (track.dataset.sizedGallery) return;
    track.dataset.sizedGallery = 'true';
    track.addEventListener('scroll', () => sizeVelaiGallery(track), {passive: true});
    track.querySelectorAll('img,video').forEach(media => {
      media.addEventListener('load', () => sizeVelaiGallery(track));
      media.addEventListener('loadedmetadata', () => sizeVelaiGallery(track));
    });
    new ResizeObserver(() => sizeVelaiGallery(track)).observe(track);
    sizeVelaiGallery(track);
  });
}
initializeVelaiGalleries();
document.addEventListener('shopify:section:load', event => initializeVelaiGalleries(event.target));
document.addEventListener('click', event => {
  document.querySelectorAll('.ritual-menu[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.ritual-menu[open]').forEach(menu => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});

// Forms owns submission and the discount. These styles apply only to the
// Circle's open shadow roots in this theme; the app's global settings stay intact.
function initializeVelaiCircle(root = document) {
  const circle = root.querySelector('#VelaiCircle');
  if (!circle || circle.dataset.circleTypography) return;
  circle.dataset.circleTypography = 'true';
  const observed = new WeakSet();
  const theme = getComputedStyle(circle);
  const typography = `
    :host { max-width:100%; min-width:0; }
    h1,h2,[role="heading"] {
      font-family:${theme.getPropertyValue('--heading')}!important;
      font-size:clamp(32px,3.5vw,44px)!important;
      line-height:1.15!important;
    }
    p { font-size:18px!important; line-height:1.5!important; }
    input,select,textarea,button { font-size:16px!important; }
    small { font-size:14px!important; line-height:1.5!important; }
  `;
  function styleShadow(shadow) {
    if (!shadow || observed.has(shadow)) return;
    observed.add(shadow);
    const style = document.createElement('style');
    style.dataset.velaiCircleStyle = 'true';
    style.textContent = typography;
    shadow.append(style);
  }
  function discover() {
    circle.querySelectorAll('[data-form-root] *').forEach(host => {
      if (host.shadowRoot) styleShadow(host.shadowRoot);
      else if (host.localName.includes('-')) {
        customElements.whenDefined(host.localName).then(() => styleShadow(host.shadowRoot));
      }
    });
  }
  new MutationObserver(discover).observe(circle, {childList:true, subtree:true});
  discover();
}
initializeVelaiCircle();
document.addEventListener('shopify:section:load', event => initializeVelaiCircle(event.target));
